import { render, staticRenderFns } from "./CustomerInactivityInfoTabs.vue?vue&type=template&id=59f84622&scoped=true&"
import script from "./CustomerInactivityInfoTabs.vue?vue&type=script&lang=ts&"
export * from "./CustomerInactivityInfoTabs.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerInactivityInfoTabs.vue?vue&type=style&index=0&id=59f84622&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f84622",
  null
  
)

export default component.exports